// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./polyfill";
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router/index";
import VueAxios from "vue-axios";
import axios from "axios";
import store from "./store";

Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.router = router;

Vue.use(require("@websanova/vue-auth"), {
  auth: {
    request: function(req, token) {
      this.options.http._setHeaders.call(this, req, {
        Authorization: "Bearer " + token
      });
    },

    response: function(res) {
      var token = res.data.token;
      return token;
    }
  },
  loginData: { url: "/auth/login", fetchUser: true },
  fetchData: { enabled: false },
  refreshData: { enabled: false },
  registerData: { url: "/auth/register", method: "POST", redirect: "/" },
  authRedirect: { path: "/auth/login" },
  notFoundRedirect: { path: "/404" },
  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js")
});

import dotenv from "dotenv";
dotenv.config();

Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});
